import React, { useEffect } from 'react'
import CustomDivider from '../shared/utils/CustomDivider'
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material'
import { Page_Padding } from '../shared/constants'
import { useGetContentDetail } from '../assets/nodeApi/getApi/ContentGetApi'
import { usePageContentWithMeta } from '../shared/hook/usePageContentWithMeta'

const RefundPolicy = ({ onLoadingChange }) => {
    const { data: Detail, isLoading } = usePageContentWithMeta("REFUND_POLICY");
    useEffect(() => {
        onLoadingChange(isLoading);
    }, [isLoading, onLoadingChange]);

    if (isLoading) return null;
    return (
        // <Box sx={{ padding: Page_Padding }}>
        //     <CustomDivider size={20} />
        //     <Typography variant='h1' fontWeight={"bold"}>REFUND POLICY FOR MySkill Club</Typography>
        //     <CustomDivider size={10} />
        //     <Typography variant='h5' fontWeight={"bold"}>Detailed Terms and Conditions for MySkill  Club :https://MySkill. Club/tnc/</Typography>
        //     <CustomDivider size={10} />
        //     <Typography variant="body2">
        //         Detailed Terms and Conditions for MySkill
        //         Club :https://MySkill. Club/tnc/
        //         At MySkill Club (hereinafter  “we”/ “our”/ “us”),
        //         we value the trust of our customers. In order to
        //         honour that trust, we have created this refund
        //         policy (“Policy”) to work in a transparent manner.
        //     </Typography>
        //     <List component={"ol"} sx={{ listStyleType: 'upper-roman', pl: 2 }}>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={<Typography variant='body2'>
        //                 Objective: The objective of this Policy is to ensure
        //                 transparency in refund process & complete
        //                 satisfaction of our Customers. This Policy enables
        //                 that the refunds (if any) are processed in a fair
        //                 manner.
        //             </Typography>} />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={<Typography variant='body2'>
        //                 Scope: This Policy is applicable to processing of any
        //                 refund of applicable fees paid by the customers who
        //                 have subscribed to our Community program
        //                 (hereinafter “Customers”/ “you”/ “your”) for
        //                 enrolling their wards from Age 3 to Age 14
        //                 (“Students”) to the our program, for (a) Trial
        //                 Classes; and or for such number of classes
        //                 (“Classes”) as more particularly identified in the
        //                 order form (“Customer Order Verification Form”)
        //                 submitted by the Customer at the time of enrolling
        //                 the Student for the respective Course(s) (hereinafter
        //                 each a “Course”) under MySkill Club program
        //                 (hereinafter “MCP”).
        //             </Typography>} />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={<Typography variant='body2'>
        //                 Validity: This Policy is effective from 09-
        //                 Novemeber-24 and shall continue to remain valid
        //                 until it is specifically replaced/ revoked by us. Any
        //                 refund request, received from you on or after 09-
        //                 Novemeber-24, will be processed in accordance with
        //                 this Policy (including any subsequent amendments or
        //                 modifications to this Policy)
        //             </Typography>} />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <Typography variant='h6' fontWeight={"bold"}>Process for Requesting Refunds:</Typography>
        //             <List component={"ol"} sx={{ listStyleType: 'decimal', pl: 2 }}>
        //                 <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                     <ListItemText primary={<Typography variant='body2'>
        //                         Obligation of Customer: If a Customer wants
        //                         to withdraw the enrolment of a Student from
        //                         MCP, such Customer will be required to contact
        //                         on +91-9845026788 and also share application
        //                         for withdrawal/ refund (“Application”) via email
        //                         refunds@myskill.club stating the reasons for
        //                         seeking such refund. The date of receipt of the
        //                         duly filled-in Application (“Submission Date”),
        //                         with all the relevant details captured correctly,
        //                         will be taken into consideration for the purpose
        //                         of calculation of the refund amount. In case of
        //                         any deviations from these requirements, the
        //                         Application shall not be considered for any
        //                         refund.
        //                     </Typography>} />
        //                 </ListItem>
        //                 <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                     <Typography variant='h6' fontWeight={"bold"}>Applicable Fees and Refunds</Typography>
        //                     <List component={"ol"} sx={{ listStyleType: 'lower-alpha', pl: 2 }}>
        //                         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                             <ListItemText primary={<Typography variant='body2'>
        //                                 Charges for MCP Trial Classes: A
        //                                 Customer can opt for availing MCP Trial
        //                                 Classes on trial basis for payment of a non-
        //                                 refundable amount, as more particularly
        //                                 mentioned in the respective Customer
        //                                 Order Verification Form (hereinafter “Trial
        //                                 Class Fee”). The Customer shall not be
        //                                 eligible for any refund of Trial Class Fee in
        //                                 case of cancellation of such MCP Trial
        //                                 Classes by the Customer.
        //                             </Typography>} />
        //                         </ListItem>
        //                         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                             <ListItemText primary={<Typography variant='body2'>
        //                                 Course Learning Program
        //                                 Fee: Customer shall be required to pay
        //                                 one-time upfront fees for availing MCP
        //                                 Classes for the Student (“Course
        //                                 Learning Program Fee” as more
        //                                 particularly mentioned in the Customer
        //                                 Order Verification Form). The Course
        //                                 Learning Program Fee shall be fully
        //                                 refundable (as per Table A below) in case
        //                                 any Application is received by us for
        //                                 withdrawal of admission by the Customer
        //                                 prior to completion of Seven (7) calendar
        //                                 days after the Orientation Date,
        //                                 (hereinafter “MySkill Club Refund Period”), i.e.
        //                                 within a period of 7 calendar days from the
        //                                 Orientation Date, including the Orientation
        //                                 Date. No Course Learning Program Fee
        //                                 shall be refunded to the Customer in case
        //                                 of any withdrawal of admission, for which,
        //                                 the Application is received by us after
        //                                 completion of the MCP Refund Period, as
        //                                 mentioned above.
        //                             </Typography>} />
        //                         </ListItem>
        //                         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                             <ListItemText primary={<Typography variant='body2'>
        //                                 Provided hereunder are certain key aspects
        //                                 that need to be taken into account for the
        //                                 purposes of calculation of refund amount.
        //                             </Typography>} />
        //                             <List component={"ol"} sx={{ listStyleType: 'decimal', pl: 2 }}>
        //                                 <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                                     <ListItemText primary={<Typography variant='body2'>
        //                                         Orientation Date: Such date for the
        //                                         first class of MCP except for the trial
        //                                         classes, as specifically registered by
        //                                         the Customer with us, when the
        //                                         Student shall be provided the
        //                                         requisite orientation for MCP Classes.
        //                                     </Typography>} />
        //                                 </ListItem>
        //                                 <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                                     <ListItemText primary={<Typography variant='body2'>
        //                                         MCP Classes are available for monthly
        //                                         subscription at a time, whereby each
        //                                         of such monthly periods from the
        //                                         Orientation Date will be referred to as
        //                                         each calendar month shall be referred
        //                                         to as a “Month”.
        //                                     </Typography>} />
        //                                 </ListItem>
        //                                 <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                                     <ListItemText primary={<Typography variant='body2'>
        //                                         For claiming refunds of Course
        //                                         Learning Program Fees,  (hereafter
        //                                         collectively referred to as “MCP
        //                                         Components”), as more particularly
        //                                         mentioned in the respective Customer
        //                                         Order Verification Form basis the
        //                                         services availed, please refer to the
        //                                         Table A and Table B (as applicable)
        //                                         for understanding the scenarios
        //                                         detailed hereunder.
        //                                     </Typography>} />
        //                                     <Typography variant='h6' fontWeight={"bold"} textAlign={"center"}>Table A</Typography>
        //                                     <Typography variant='h6' fontWeight={"bold"} textAlign={"center"}>Course Learning Program</Typography>
        //                                     <Typography variant='h6' fontWeight={"bold"} textAlign={"center"}>Before Course Commencement -
        //                                         100% Refundable</Typography>
        //                                     <Typography variant='h6' fontWeight={"bold"} textAlign={"center"}>Within 7 Days of Course
        //                                         Commencement - 50%
        //                                         Refundable</Typography>
        //                                     <Typography variant='h6' fontWeight={"bold"} textAlign={"center"}>After 7 Days of Course
        //                                         Commencement - 0%</Typography>

        //                                 </ListItem>
        //                             </List>
        //                         </ListItem>
        //                     </List>
        //                 </ListItem>

        //             </List>
        //         </ListItem>




        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <Typography variant='h6' fontWeight={"bold"}>Mode of Refund:</Typography>
        //             <List component={"ol"} sx={{ listStyleType: 'decimal', pl: 2 }}>
        //                 <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                     <ListItemText primary={<Typography variant='body2'>
        //                         No MCP Components will be refunded in
        //                         cash. All applicable refunds shall be paid
        //                         through cheques or online transfer ONLY, to the
        //                         source account of the Customer from where the
        //                         payment was originally made, within a
        //                         reasonable period of thirty (30) calendar days
        //                         from the date on which a written confirmation is
        //                         provided to the Customer for approval of such
        //                         refund. Further, all refund(s) shall be processed
        //                         in Indian Rupees only.
        //                     </Typography>} />
        //                 </ListItem>
        //                 <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                     <ListItemText primary={<Typography variant='body2'>
        //                         In the event your payment instrument/ account
        //                         through which original payment was made, is
        //                         not active or does not support refunds, you shall
        //                         be required to provide other bank account
        //                         details belonging to you for processing the
        //                         relevant refund. We shall not be held
        //                         responsible and/ or accountable for crediting
        //                         refund money to the wrong account due to
        //                         incorrect details furnished by you. You shall be
        //                         required to furnish a declaration for transfer of
        //                         refund to another bank account in the format
        //                         and manner as may be required by us.
        //                     </Typography>} />
        //                 </ListItem>
        //                 <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                     <ListItemText primary={<Typography variant='body2'>
        //                         In case you have not received the refund approved by us, in writing, within the above mentioned thirty (30) calendar days period, then please write to us at support@myskill.club
        //                     </Typography>} />
        //                 </ListItem>
        //             </List>
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <Typography variant='h6' fontWeight={"bold"}>Important Terms & Conditions</Typography>
        //             <List component={"ol"} sx={{ listStyleType: 'decimal', pl: 2 }}>
        //                 <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                     <ListItemText primary={<Typography variant='body2'>
        //                         You represent and warrant that any information
        //                         that is provided to us or submitted in the
        //                         Customer Order Verification Form and related
        //                         documents for enrolling the Student in the MCP,
        //                         is accurate, true and current. Any deviation
        //                         from this will result in immediate cancellation of
        //                         Student’s enrolment with no refund thereof and
        //                         the Classes will not be resumed for such
        //                         Student under any circumstances.
        //                     </Typography>} />
        //                 </ListItem>
        //                 <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                     <ListItemText primary={<Typography variant='body2'>
        //                         You understand that – (a) failure to raise a
        //                         request for rescheduling the MCP Trial Class 72
        //                         hours prior to the registered slot; or (b) failure
        //                         to avail the MCP Trial Class after rescheduling
        //                         the registered slot for such MCP Trial Class, may
        //                         lead to cancellation of the MCP Trial Class, for
        //                         which no refund shall be provided to you.
        //                     </Typography>} />
        //                 </ListItem>
        //                 <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                     <ListItemText primary={<Typography variant='body2'>
        //                         You also understand that we may cancel the
        //                         MCP Trial Class or your subscription to MCP
        //                         Classes on account of discovery of credible
        //                         proof regarding any breach of MCP Terms or
        //                         Terms of Use, without providing any refunds.
        //                         You will not have any claim towards, and we will
        //                         not have any liability towards any termination
        //                         which is undertaken as a result of the
        //                         aforementioned event.
        //                     </Typography>} />
        //                 </ListItem>
        //                 <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                     <ListItemText primary={<Typography variant='body2'>
        //                         MySkill Club reserves the right to discontinue, in
        //                         any specific location, any or all aspect(s),
        //                         services, features or functionality of MCP as it
        //                         deems fit, at any time with prior notice of not
        //                         less than 30 (thirty) days, without any obligation
        //                         to assign any reasons for such discontinuation
        //                         (“Discontinuation Event”). In the event of an
        //                         occurrence of a Discontinuation Event, which
        //                         has an impact on MCP in your location, you shall
        //                         (i) receive communication from us wherein you
        //                         will be intimated, inter-alia, of such withdrawal/
        //                         discontinuation of MCP in your location, the date
        //                         of withdrawal/ discontinuation of MCP in your
        //                         location (“Discontinuation Date”), along with
        //                     </Typography>} />
        //                 </ListItem>
        //                 <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                     <ListItemText primary={<Typography variant='body2'>
        //                         If a Student is terminated from the MCP on
        //                         account of any disciplinary action taken against
        //                         such Student, then we shall not be liable for any
        //                         refunds to you. The decision of the MCP Area
        //                         Business Head, in this regard will be final and
        //                         binding on you. In any such cases, enrolment of
        //                         the Student will be considered as cancelled and
        //                         the Classes will not be resumed for such
        //                         Student under any circumstances.
        //                     </Typography>} />
        //                 </ListItem>
        //                 <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                     <ListItemText primary={<Typography variant='body2'>
        //                         We shall be not be liable for any delay or failure
        //                         to perform its obligations (in total or in part) if
        //                         such delay or failure is due to any cause(s)
        //                         including but not limited to, acts of God, strikes,
        //                         lockouts, riots, lockdown, government
        //                         restrictions, sanctions, wars, terrorism,
        //                         insurrections, civil disturbances, earthquake,
        //                         weather, fire, epidemic, pandemic, lockdown,
        //                         explosions, and/or any other cause beyond our
        //                         reasonable control making the performance of
        //                         our obligations/ services inadvisable,
        //                         commercially impracticable, illegal, or
        //                         impossible (“Force Majeure Event“). We shall
        //                         not be held liable for not being able to conduct
        //                         the Classes at the respective location required
        //                         by you and that such Classes may be
        //                         held/conducted in online mode in the interim in
        //                         compliance with the laws, rules and/or
        //                         regulations as may be applicable under the law
        //                         for time being in force. Accordingly, no refund
        //                         shall be provided to you in such case. Also, in
        //                         case Classes may not be conducted in any mode
        //                         (offline and/or online), or if conducting the
        //                         Classes is prohibited as per the applicable laws,
        //                         guidelines, regulations, during such period of
        //                         Force Majeure Event, then also no refund shall
        //                         be applicable as, in such cases, we will
        //                         appropriately suspend the Classes during the
        //                         continuation of the Force Majeure Event, and
        //                         shall resume the Classes post the Force Majeure
        //                         Event thereby accordingly extending the
        //                         duration of MCP program availed by the
        //                         Customer.
        //                     </Typography>} />
        //                 </ListItem>
        //                 <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                     <ListItemText primary={<Typography variant='body2'>

        //                         MySkill Club reserves the right to discontinue, in
        //                         any specific location, any or all aspect(s),
        //                         services, features or functionality of MCP as it
        //                         deems fit, at any time with prior notice of not
        //                         less than 30 (thirty) days, without any obligation
        //                         to assign any reasons for such discontinuation
        //                         (“Discontinuation Event”). In the event of an
        //                         occurrence of a Discontinuation Event, which
        //                         has an impact on MCP in your location, you shall
        //                         (i) receive communication from us wherein you
        //                         will be intimated, inter-alia, of such withdrawal/
        //                         discontinuation of MCP in your location, the date
        //                         of withdrawal/ discontinuation of MCP in your
        //                         location (“Discontinuation Date”), along with
        //                         the refund process, applicable refunds, mode of
        //                         refund and other applicable terms and
        //                         conditions, through calls/ SMS/ email on your
        //                         contact details registered with us under MCP
        //                         (“Discontinuation Communication”); (ii) be
        //                         eligible for a refund of the pro-rated Course
        //                         Learning Program Fee (based on the number of
        //                         Months for which MCP has been provided by us
        //                         from the Orientation Date upto the
        //                         Discontinuation Date) and pro-rated Home
        //                         Tuitions Fee (based on the number of Classes
        //                         exhausted from the Orientation Date upto the
        //                         Discontinuation Date); (iii) be eligible for the
        //                         Device Fee if the Discontinuation Date occurs
        //                         within fourteen (14) calendar days after the
        //                         Course Delivery Date, whereby the process for
        //                         return of Course (without any damage) shall be
        //                         in accordance with paragraph IV(2)(d) of this
        //                         Policy and/ or the Discontinuation
        //                         Communication; (iv) in case we are unable to
        //                         provide the MCP Trial Classes to the Student,
        //                         you shall be eligible for a full refund of the Trial
        //                         Class Fee.
        //                     </Typography>} />
        //                 </ListItem>
        //                 <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                     <ListItemText primary={<Typography variant='body2'>
        //                         Any other refund policy, mentioned anywhere
        //                         on our website or any other place, does not hold
        //                         true for the Classes offered under MCP.
        //                     </Typography>} />
        //                 </ListItem>
        //                 <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //                     <ListItemText primary={<Typography variant='body2'>
        //                         On account of withdrawal of admission by you,
        //                         the services to be provided by us, from
        //                         Submission Date up to completion of Classes,
        //                         shall be considered as services not
        //                         performed. Accordingly, we will issue a GST
        //                         credit note to you, which otherwise may not be
        //                         issued if the withdrawal and issuance are
        //                         beyond the timelines allowed under applicable
        //                         law. In case the Submission Date is after the
        //                         prescribed timeline, we may issue a commercial
        //                         credit note, on your request.
        //                     </Typography>} />
        //                 </ListItem>
        //             </List>
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={<Typography variant='body2'>
        //                 Changes to this Policy: We reserve the right to
        //                 modify/ amend/ replace this Policy at any time, as
        //                 deemed fit by us, without any prior notice to you.
        //             </Typography>} />
        //         </ListItem>
        //     </List>

        // </Box >

        <Box sx={{ padding: Page_Padding }}>
            <div dangerouslySetInnerHTML={{ __html: Detail?.content?.[0]?.data?.detail }} />
        </Box>
    )
}

export default RefundPolicy